import styled from 'styled-components';
import { tabletPortraitMinWidth } from '../../appComponents/cssConstants';

const EmptyFieldForTwoColumnForm = styled.div`
	display: none;

	@media (min-width: ${tabletPortraitMinWidth}) {
		display: inline-block;
		margin-bottom: 10px;
	}
`;

export default EmptyFieldForTwoColumnForm;
